export const formatDate = async (dateValue) => {
  return dateValue.toLocaleDateString();
}